import classNames from 'classnames';
import { signOut } from 'next-auth/react';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './main-navigation-shared-profile-dropdown.module.scss';

export interface MainNavigationSharedProfileDropdownProps {
  /** Indicates whether the profile dropdown is open */
  isProfileMenuOpen?: boolean;
  /** An array of profile login link items */
  profileMenuItems: Content.Properties.ProfileMenuItem[];
}

const MainNavigationSharedProfileDropdown = ({
  isProfileMenuOpen,
  profileMenuItems,
}: MainNavigationSharedProfileDropdownProps) => {
  const handleProfileMenuItemClick =
    (item: Content.Properties.ProfileMenuItem) =>
    async (event?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
      if (item.type !== 'logout') return;

      event?.preventDefault();

      await signOut({ callbackUrl: '/' });
    };

  return (
    <div
      className={classNames(styles.component, {
        [styles.isProfileMenuOpen]: isProfileMenuOpen,
      })}
    >
      <div className={styles.container}>
        <div className={styles.items}>
          {profileMenuItems.map((item, itemIndex) => (
            <Link
              key={itemIndex}
              className={styles.itemLink}
              onClick={handleProfileMenuItemClick(item)}
              url={item.link.url}
            >
              <Typography className={styles.text} tagStyle="labelLarge">
                {item.link.text}
              </Typography>

              <Icon name={item.icon} size={16} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

MainNavigationSharedProfileDropdown.displayName =
  'MainNavigationSharedProfileDropdown';

export default MainNavigationSharedProfileDropdown;
